import Emitter from "./Emitter";

export default class GameLaunchUrl extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(payload) {
        this.emitTop({ wpgaction: "getGameLaunchUrl", data: { "gameCode": payload.data.gameCode, "refId": payload.data.refId, "playMode": payload.data.playMode } });
    }
}


